'use client'

// React Imports
import { useEffect } from 'react'

// Next Imports
import { usePathname, useRouter } from 'next/navigation'

// Util Imports
import { SESSION_EXPIRED_EVENT, resetSessionExpiredLatch } from '@/libs/sessionExpiry'
import { clearSession } from '@/utils/session'

// The navigation half of the global 401 interceptor (round #101): libs/api.ts has
// no React context, so it raises a DOM event and this root-level listener owns the
// router. Mounted once in the root layout, it covers the dashboard AND the
// blank-layout pages (console). The latch in libs/sessionExpiry collapses
// concurrent 401s into one redirect; it re-arms here on every completed
// navigation — and the interceptor never fires on /login, so no loop.
const SessionExpiredRedirect = () => {
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    resetSessionExpiredLatch()
  }, [pathname])

  useEffect(() => {
    const onExpired = () => {
      clearSession()
      router.push('/login')
    }

    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired)

    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired)
  }, [router])

  return null
}

export default SessionExpiredRedirect
